<mat-card class="mat-shadow" [ngClass]="marginTopZero? 'mt-0': ''" layout-align="center center">
  <ng-content></ng-content>
</mat-card>